import { DecodeVinValues } from '@shaggytools/nhtsa-api-wrapper';

export const getCarInfoFromVin = async (vin: string) => {
  return DecodeVinValues(vin)
    .then(vin => {
      const { Make, Model, ModelYear, BodyClass, TransmissionStyle, Seats } = vin.Results[0];
      return { Make, Model, ModelYear, BodyClass, TransmissionStyle, Seats };
    })
    .catch(error => {
      throw error;
    });
};
